module.exports = __webpack_public_path__ + "static/media/detail_0044_t.46efa433.jpg";